"use client";

import clsx from 'clsx';
import Link from 'next/link';
import { PrismicNextLink } from '@prismicio/next'; // Import PrismicNextLink
import { linkResolver } from "@/app/lib/linkResolver"; // Import linkResolver (if not already defined)
import { formatLink, formatTarget } from '@/app/lib/utils';
import { isFilled } from '@prismicio/helpers'; // Import isFilled

export const triggerSquadUpModal = (eventId) => {
  
  if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.modal === 'undefined') {
      console.error("Cannot show modal: jQuery or Bootstrap modal function not ready.");
      return;
  }

  const $ = window.jQuery;
  const modalId = '#squadupGlobalModal'; // The ID from layout.tsx
  
  window.squadup = Object.assign(window.squadup || {}, {
      eventId: eventId,
      showCheckout: false,
      ...(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY
        ? {
            stripePublicKey: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY,
            stripeJsVersion: 'v3',
          }
        : {}),
  });
  
  document.dispatchEvent(new CustomEvent('destroySquadupEmbed'));
  
  $(modalId).off('shown.bs.modal').on('shown.bs.modal', function() {
      document.dispatchEvent(new CustomEvent('createSquadupEmbed'));
  });

  $(modalId).modal('show');
};

export function ConditionalLink({ url, children, squadupeventid, className, target = null, condition = true, style = null, onClick = null, ...props }) {

  const handleBuyTicketsClick = (e, eventId) => {
    e.preventDefault();
    triggerSquadUpModal(eventId);
    if (onClick) {
        onClick(e); // Propagate click event if present
    }
  };

  // Check for Prismic link object structure
  const isPrismicLink = url && (url.link_type === 'Web' || url.link_type === 'Document' || url.link_type === 'Media');
  const linkUrl = isPrismicLink ? url : url;
  const href = formatLink(linkUrl);
  const hasHash = href.includes('#');
  const linkTarget = target || formatTarget(linkUrl);
  const linkRel = linkTarget === '_blank' ? 'noopener noreferrer' : undefined;

  if (isFilled.keyText(squadupeventid)) {
    return (
      <div
        className={clsx(className, 'cursor-pointer')}
        style={style}
        onClick={(e) => handleBuyTicketsClick(e, squadupeventid)}
        {...props}
      >
        {children}
      </div>
    );
  } else if (linkUrl && condition) {
    if (isPrismicLink && linkResolver) {
        return (
            <PrismicNextLink 
                field={linkUrl} 
                linkResolver={linkResolver} 
                className={className} 
                style={style} 
                onClick={onClick}
                scroll={!hasHash}
                {...props}
                // target prop is not typically used directly on PrismicNextLink when field is present,
                // Prismic handles target internally, but we'll include it for completeness if needed for external links
                target={linkTarget}
                rel={linkRel}
            >
                {children}
            </PrismicNextLink>
        );
    } else {
      // Regular internal/external link using Next's Link component
      return (
        <Link
          href={href}
          scroll={!hasHash}
          target={linkTarget}
          rel={linkRel}
          className={className}
          style={style}
          onClick={onClick}
          {...props}
        >
          {children}
        </Link>
      );
    }
  } else {
    return <div className={className} style={style} {...props}>{children}</div>;
  }
}